import { Component, Input, OnInit } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity } from '@m4u-angular/base/entities/BaseEntities';
import {
    EnumNotificationDeliveryOptions, EnumPageDisplayModes,
    EnumPageEntitySources, EnumSystemOptions
} from '@m4u-angular/core/framework/sysenums.enum';

class State {
    NotificationDeliveryOptions: any[] = [];
    UserCreationOptions: any[] = [];
    NotificationDeliveryOption: EnumNotificationDeliveryOptions;
    UserCreationOptionID: number = 0;
    Languages: any[] = [];
    LanguageID: string = 'HE';
}

@Component({
    selector: 'app-welcome-message-config-dialog',
    templateUrl: './welcome-message-config-dialog.component.html',
    styleUrls: ['./welcome-message-config-dialog.component.scss']
})
export class WelcomeMessageConfigDialogComponent extends BasePageComponent<BaseEntity, State> {
    @Input() ShowUserCreationOption: boolean;

    constructor(A: ServiceBagService) {
        super(A, 'WelcomeMessageConfigDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);

    }

    override OnInitTitle() {
        return this.ShowUserCreationOption ? 'Credential creation' : this.RC('Pages.WelcomeMessageConfigDialogComponent');
    }

    protected override OnInitComponent() {
        this.State.NotificationDeliveryOptions = this.LIST('WelcomeDeliveryOptions')
            .sort((a, b) => a.SortOrder > b.SortOrder ? 1 : -1)
            .filter(x => {
                switch (x.Value) {
                    case EnumNotificationDeliveryOptions.Email:
                        return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodEmail);
                    case EnumNotificationDeliveryOptions.SMS:
                        return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodSMS);
                    case EnumNotificationDeliveryOptions.WhatsApp:
                        return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodWhatsApp);
                    default:
                        break;
                }
                return true;
            });
        if (!this.ShowUserCreationOption) {
            this.State.NotificationDeliveryOptions = this.State.NotificationDeliveryOptions
                .filter(x => x.Value !== EnumNotificationDeliveryOptions.DontSend);
        }
        this.State.NotificationDeliveryOption = this.State.NotificationDeliveryOptions[0]?.Value;
        this.State.UserCreationOptions = this.LIST('UserCreationOptions');
        this.State.Languages = this.LIST('Languages');
    }
}